const resourcesData = [
  {
    id: 1,
    title: "HIV and Covid-19 Prevention",
    description:
      "Envision Health Access Initiative recognizes the disproportionate impact of the pandemic on vulnerable populations, including those living with HIV, and strives to equip them with the knowledge and resources necessary to avoid COVID-19, protect themselves and others, and promote community health.",
    urlBtn: "/resources/hiv-covid-19",
    img: "img/covidPic.jpg",
  },
  {
    id: 2,
    title: "Our financial reports",
    description:
      "Our commitment to transparency is reflected in our annual financial reports, which are readily available to all of our funders. You can have confidence that your donations are being used to make a positive impact in communities around the world.",
    urlBtn: "/resources/financial-report",
    img: "img/financialPic.jpg",
  },
];

export default resourcesData;
